export default __webpack_public_path__ + "static/media/attention.fb31867f.png";